import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Button = styled(View, theme => {
  return {
    base: {
      display: 'flex',
    },
    variants: {
      isActive: {
        true: {
          display: 'none',
        },
      },
    },
  }
})
